import styles from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function SleekDesign() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.SleekDesign');
    return (
        <div className={`${styles.sleekDesign}`}>
            <div className="solution-item">
                <div className="text-box">
                    <div className="sub-title">{t('label')}</div>
                    <h2 className="title">{t('title')}</h2>
                    <div className="desc">{t('desc')}</div>
                </div>
                <div className="img-box">
                    <div className="bg-img">
                        <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713522972207/Design-1-tuya.jpg" alt={t('title')} />
                    </div>
                    <div className="bg-img-h5">
                        <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713522993134/Design-1%20(1)-tuya.jpg" alt={t('title')} />
                    </div>
                    <div className="bg-img">
                        <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713522977625/Design-2-tuya.jpg" alt={t('title')} />
                    </div>
                    <div className="bg-img-h5">
                        <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713522998597/Design-2%20(1)-tuya.jpg" alt={t('title')} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
